import { ValueOP } from '@ibiz-template/runtime';

/**
 * @description 获取所有过滤模式
 * @export
 * @returns {*}  {{
 *   valueOP: ValueOP;
 *   label: string;
 * }[]}
 */
export function getAllFilterModes(): {
  valueOP: ValueOP;
  label: string;
}[] {
  return [
    {
      valueOP: ValueOP.EQ,
      label: ibiz.i18n.t('control.searchBar.conditions.eq'),
    },
    {
      valueOP: ValueOP.NOT_EQ,
      label: ibiz.i18n.t('control.searchBar.conditions.not_eq'),
    },
    {
      valueOP: ValueOP.GT,
      label: ibiz.i18n.t('control.searchBar.conditions.gt'),
    },
    {
      valueOP: ValueOP.GT_AND_EQ,
      label: ibiz.i18n.t('control.searchBar.conditions.gt_and_eq'),
    },
    {
      valueOP: ValueOP.LT,
      label: ibiz.i18n.t('control.searchBar.conditions.lt'),
    },
    {
      valueOP: ValueOP.LT_AND_EQ,
      label: ibiz.i18n.t('control.searchBar.conditions.lt_and_eq'),
    },
    {
      valueOP: ValueOP.IS_NULL,
      label: ibiz.i18n.t('control.searchBar.conditions.is_null'),
    },
    {
      valueOP: ValueOP.IS_NOT_NULL,
      label: ibiz.i18n.t('control.searchBar.conditions.is_not_null'),
    },
    {
      valueOP: ValueOP.IN,
      label: ibiz.i18n.t('control.searchBar.conditions.in'),
    },
    {
      valueOP: ValueOP.NOT_IN,
      label: ibiz.i18n.t('control.searchBar.conditions.not_in'),
    },
    {
      valueOP: ValueOP.LIKE,
      label: ibiz.i18n.t('control.searchBar.conditions.like'),
    },
    {
      valueOP: ValueOP.LEFT_LIKE,
      label: ibiz.i18n.t('control.searchBar.conditions.left_like'),
    },
    {
      valueOP: ValueOP.RIGHT_LIKE,
      label: ibiz.i18n.t('control.searchBar.conditions.right_like'),
    },
    {
      valueOP: ValueOP.EXISTS,
      label: ibiz.i18n.t('control.searchBar.conditions.exists'),
    },
    {
      valueOP: ValueOP.NOT_EXISTS,
      label: ibiz.i18n.t('control.searchBar.conditions.not_exists'),
    },
  ];
}
